module.exports = __webpack_public_path__ + "img/icon_map_0_c.1cd3a150.png";